import { createApp } from 'vue';
import OrfToPngConverter from '../Components/OrfToPngConverter.vue';

const root = document.getElementById('orf-to-png-converter');
if (root) {
  createApp(OrfToPngConverter).mount('#orf-to-png-converter');
}
